import { useMemo } from 'react';
import { IWithExportProps } from './interface';
import { IChartOptions } from '../base-chart/interface';

export const withExport =
  (Component: any) =>
  ({ enableExport = false, ...props }: IWithExportProps & IChartOptions) => {
    if (!enableExport) return <Component {...props} />;

    const configWithExport = useMemo(() => {
      return {
        ...(props?.chartOptions ?? {}),
        exporting: {
          enabled: enableExport,
          filename: 'Mais-Retorno-grafico-rentabilidade',
          buttons: {
            contextButton: {
              align: 'right',
              y: -30,
              x: 0,
              menuItems: ['downloadXLS', 'downloadCSV'],
            },
          },
        } as Highcharts.ExportingOptions,
      };
    }, [enableExport]);

    return <Component {...props} chartOptions={configWithExport} />;
  };
